<template>
  <div>
    <div class="container">
      <div class="page">
        <h1 id="about">Ошибка 404</h1>
        <p>
          Страница не найдена
        </p>
      </div>
    </div>
  </div>
</template>


<script>
// @ is an alias to /src
export default {
  name: 'pageNotFound'
}
</script>